import { render, staticRenderFns } from "./LightboxService.vue?vue&type=template&id=ea31aa52&"
import script from "./LightboxService.vue?vue&type=script&lang=js&"
export * from "./LightboxService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports